import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations } from './translations';
type Language = 'en' | 'es';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => any;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  useEffect(() => {
    // 1. Honor a previously saved choice, otherwise 2. auto-detect from the browser.
    const saved = localStorage.getItem('blinkblis-lang') as Language | null;
    if (saved === 'en' || saved === 'es') {
      setLanguage(saved);
      return;
    }
    const browserLang = navigator.language.toLowerCase();
    if (browserLang.startsWith('es')) {
      setLanguage('es');
    }
  }, []);
  useEffect(() => {
    // Persist the choice and reflect it on <html lang> for a11y / SEO.
    localStorage.setItem('blinkblis-lang', language);
    document.documentElement.lang = language;
  }, [language]);
  const t = (key: string) => {
    const keys = key.split('.');
    let value: any = translations[language];
    for (const k of keys) {
      if (value === undefined) return key;
      value = value[k];
    }
    return value || key;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-346">
      {children}
    </LanguageContext.Provider>;
}
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};